import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    showModal: false,
    showRegModal: false,
    showForgotModal: false,
    showGuestModal: false,
    loginStatus: false,
    mobile: '',
    operator: '',
    connectionType: '',
    amount: '',
    method: '',
    totalAmount: '',
    authUser: '',
    popularPackages: '',
    isGuest: false,
    showContactUs: false
  },
  mutations: {
    showModal(state,modalValue) {
      state.showModal = modalValue
    },
    showRegModal(state,modalValue) {
      state.showRegModal = modalValue
    },
    showForgotModal(state,modalValue) {
      state.showForgotModal = modalValue
    },
    showGuestModal(state,modalValue) {
      state.showGuestModal = modalValue
    },
    loginStatus(state,statusValue) {
      state.loginStatus = statusValue
    },
    setMobile(state,value) {
      state.mobile = value
    },
    setOperator(state,value) {
      state.operator = value
    },
    setConnectionType(state,value) {
      state.connectionType = value
    },
    setAmount(state,value) {
      state.amount = value
    },
    setMethod(state,value) {
      state.method = value
    },
    setTotalAmount(state,value) {
      state.totalAmount = value;
    },
    setUser(state,value) {
      state.authUser = value;
    },
    setPopularPackage(state,value) {
      state.popularPackages = value;
    },
    isGuest(state,value) {
      state.isGuest = value;
    },
    showContactUs(state, value) {
      state.showContactUs = value;
    }
  },
  actions: {
    setUser({commit},value){
      commit('setUser',value)
    },
  },
  modules: {
  }
})
